import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { AssignScheduleToPoliciesResponse, DeleteSchedulesRequestData, GetPoliciesByScheduleIdResponse, ScheduleItem, SchedulesMethod, SchedulesResponse } from '../types';

export class WebAccessControlSchedulerBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'WebAccessControlSchedules';
  private dataProviderType = DataProviderType.ENDPOINTS;

  public async getDataForView() {
    return {};
  }

  public async removeRecords(records: Array<ScheduleItem>): Promise<SchedulesResponse> {
    const payload: DeleteSchedulesRequestData = {
      records: records.map((item: ScheduleItem) => {
        const { _id, company } = item;
        return { _id, company };
      }),
    };

    return ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload: payload,
      endpoint: this.endpoint,
      method: SchedulesMethod.REMOVE_RECORDS,
    });
  }

  public async getPoliciesByWebAccessControlScheduleId(companyId: string, scheduleId: string): Promise<GetPoliciesByScheduleIdResponse> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload: {
        companyId: companyId,
        scheduleId: scheduleId,
      },
      endpoint: "PolicyTemplates",
      method: SchedulesMethod.GET_POLICIES_BY_SCHEDULE_ID,
    });
  }

  public async assignScheduleToPolicies(companyId: string, scheduleId: string, policyIds: string[]): Promise<AssignScheduleToPoliciesResponse> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload: {
        targetCompanyId: companyId,
        scheduleId: scheduleId,
        policyIds: policyIds,
      },
      endpoint: this.endpoint,
      method: SchedulesMethod.ASSIGN_SCHEDULE_TO_POLICIES,
    });
  }

}
